import React from 'react'
import styles from './DepartmentsPanel.module.scss'
import { UserDepartmentsTable } from './UserDepartmentsTable/UserDepartmentsTable'
import { AdminHeader } from './AdminHeader/AdminHeader'
import { useAdminPanel } from './hooks'
import { DeleteDepartmentAccessModal } from 'components/modals/DeleteDepartmentAccessModal/DeleteDepartmentAccessModal'

export const DepartmentsPanel = ({
  pk,
  selectedUser,
  handleManageUserOpen,
}) => {
  const {
    state: { signalTableUpdate, isDeleteDepartmentAccessOpen },
    handlers: {
      addUserDepartment,
      handleDeleteDepartmentAccessClose,
      handleDeleteDepartmentAccessConfirm,
      handleDeleteDepartmentAccessOpen,
    },
  } = useAdminPanel({ pk })

  return (
    <>
      <div className={styles.departmentsPanel}>
        <AdminHeader
          selectedUser={selectedUser}
          addUserDepartment={addUserDepartment}
          key={Number(signalTableUpdate)}
          handleManageUserOpen={handleManageUserOpen}
        />
        {selectedUser ? (
          <UserDepartmentsTable
            selectedUser={selectedUser}
            signalTableUpdate={signalTableUpdate}
            handleDeleteDepartmentAccessOpen={handleDeleteDepartmentAccessOpen}
          />
        ) : null}
      </div>
      <DeleteDepartmentAccessModal
        onCancel={handleDeleteDepartmentAccessClose}
        onClose={handleDeleteDepartmentAccessClose}
        onConfirm={handleDeleteDepartmentAccessConfirm}
        isOpen={isDeleteDepartmentAccessOpen}
      />
    </>
  )
}
